import { Dialog } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/hooks/store'
import { licenseSlice } from '@/store/licenseSlice'
import { sectorRulesSlice, selectHasRuleType } from '@/store/sectorRulesSlice'
import { PreemptionCodeContent } from './PreemptionCodeContent'
import { TaxCodeValidationContent } from './TaxCodeValidationContent'

type Props = {
  isOpen: boolean

  onConfirm: (unavailableSectors: number[]) => void
  setIsOpen: (isOpen: boolean) => void
}

export function SectorRulesDialog(props: Props) {
  const { t } = useTranslation()

  const license = useAppSelector(licenseSlice.selectors.license)
  const sectorRules = useAppSelector(sectorRulesSlice.selectors.rules)
  const hasTaxCodeValidation = useAppSelector(
    selectHasRuleType('tax-code-validation')
  )
  const hasPreemptionCodeValidation = useAppSelector(
    selectHasRuleType('preemption-code-validation')
  )

  if (license === null || sectorRules === null) {
    return null
  }

  if (hasTaxCodeValidation) {
    return (
      <Dialog
        isOpen={props.isOpen}
        setIsOpen={props.setIsOpen}
        title={t('dialog.sectorRules.title', {
          city: license?.beach.city ?? '',
        })}
        trigger={null}
      >
        <TaxCodeValidationContent
          dialogIsOpen={props.isOpen}
          onConfirm={props.onConfirm}
          sectorRules={sectorRules}
        />
      </Dialog>
    )
  }

  if (hasPreemptionCodeValidation) {
    return (
      <Dialog
        isOpen={props.isOpen}
        mobileMode="bottomSheet"
        setIsOpen={props.setIsOpen}
        size="sm"
        title={t('preemptionCode.dialog.title')}
        trigger={null}
      >
        <PreemptionCodeContent onConfirm={props.onConfirm} />
      </Dialog>
    )
  }

  return null
}
